import { Text } from '@fluentui/react';

export const RowAllocationCell = ({ allocationDisplay }: { allocationDisplay: string }) => {
    return (
        <Text as="div" className="totalCellInner">
            {allocationDisplay}
        </Text>
    );
};
